import { Button } from "@mui/material";
import React, { useEffect } from "react";
import { FormatMoney } from "../../../Helpers/FormatNumber";
import { TotalizarByProp } from "../../../Helpers/Agrupaciones/TotalizarByProp";

export const TotalCarteraMensualScreen = ({ state }) => {

    return (
        <div className="reporte-cartera-detalle-totales-container scroll">
            <table cellPadding={0} cellSpacing={0}>
                <thead>
                    <tr>
                        <th>Sucursal</th>
                        <th>
                            <div>ID</div>
                        </th>
                        <th>
                            <div>Razon Social</div>
                        </th>
                        <th>
                            <div>Documento</div>
                        </th>
                        <th>
                            <div>Vencimiento</div>
                        </th>
                        <th>
                            <div>Días</div>
                        </th>
                        <th>
                            <div>Importe</div>
                        </th>
                        <th>
                            <div>Intereses</div>
                        </th>
                        <th>
                            <div>Total</div>
                        </th>
                    </tr>
                </thead>
                <tbody>
                    {state.estado.map((estado) => (
                        <>
                            <tr className="row-encabezado estado">
                                <td>{estado}</td>
                                <td></td>
                                <td>{estado}</td>
                                <td></td>
                                <td></td>
                                <td></td>
                                <td className="row-numero">
                                    {FormatMoney(
                                        TotalizarByProp(
                                            state.data.filter((item) => item.estatus === estado),
                                            "saldo"
                                        )
                                    )}
                                </td>
                                <td className="row-numero">
                                    {FormatMoney(
                                        TotalizarByProp(
                                            state.data.filter((item) => item.estatus === estado),
                                            "interesbase"
                                        )
                                    )}
                                </td>
                                <td className="row-numero">
                                    {FormatMoney(
                                        TotalizarByProp(
                                            state.data.filter((item) => item.estatus === estado),
                                            "importe"
                                        )
                                    )}
                                </td>
                            </tr>
                            {state.lineas.map((linea) => (
                                <>
                                    <tr className="row-encabezado linea">

                                        <td>{linea}</td>
                                        <td></td>
                                        <td>{linea}</td>
                                        <td></td>
                                        <td></td>
                                        <td></td>
                                        <td className="row-numero">
                                            {FormatMoney(
                                                TotalizarByProp(
                                                    state.data.filter((item) => item.estatus === estado && item.linea === linea),
                                                    "saldo"
                                                )
                                            )}
                                        </td>
                                        <td className="row-numero">
                                            {FormatMoney(
                                                TotalizarByProp(
                                                    state.data.filter((item) => item.estatus === estado && item.linea === linea),
                                                    "interesbase"
                                                )
                                            )}
                                        </td>
                                        <td className="row-numero">
                                            {FormatMoney(
                                                TotalizarByProp(
                                                    state.data.filter((item) => item.estatus === estado && item.linea === linea),
                                                    "importe"
                                                )
                                            )}
                                        </td>
                                    </tr>
                                    {state.data
                                        .filter((item) => item.estatus === estado && item.linea === linea)
                                        .map((item, index) => (
                                            <tr className={`row-detalle ${index % 2 === 0 ? 'fila-par' : 'fila-impar'}`}>
                                                <td>{item.sucursal}</td>
                                                <td>{item.idcliente}</td>
                                                <td>
                                                    <div className="razon-social">{item.razonsocial}</div>
                                                </td>
                                                <td className="row-centrada">{item.documento}</td>
                                                <td className="row-centrada">{item.vencimiento}</td>
                                                <td className="row-centrada">{item.diasvencido < 0 ? 0 : item.diasvencido}</td>
                                                <td className="row-numero">{FormatMoney(item.saldo)}</td>
                                                <td className="row-numero">{FormatMoney(item.interesbase)}</td>
                                                <td className="row-numero">$ {FormatMoney(item.importe)}</td>
                                            </tr>
                                        ))}
                                    <tr className="row-espacio">
                                        <td colSpan={6}></td>
                                    </tr>
                                </>
                            ))}
                        </>
                    ))}

                    <tr className="row-encabezado">
                        <td></td>
                        <td>TOTALES:</td>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td className="row-numero">{FormatMoney(TotalizarByProp(state.data, "saldo"))}</td>
                        <td className="row-numero">
                            {FormatMoney(TotalizarByProp(state.data, "interesbase"))}
                        </td>
                        <td className="row-numero">{FormatMoney(TotalizarByProp(state.data, "importe"))}</td>
                    </tr>
                </tbody>
            </table>
        </div>
    );
};
